
export const SET_MSG = 'IRRF_MSG';
export const SET_EDITAR = 'IRRF_EDITAR';
export const SET_LISTA = 'IRRF_LISTA';
export const SET_BOLETINS = 'IRRF_BOLETINS';
export const SET_IRRF = 'IRRF_IRRF';